
import { defineComponent, onMounted } from "vue";
import StudentInfo from "@/views/CourseEarlyRegistration/StudentInfo.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
  name: "dashboard",
  components: {
    StudentInfo,
  },
  setup() {
    const Course = JSON.parse(localStorage.getItem("Course") || "{}");

    const { t, te } = useI18n();
    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };
    onMounted(() => {
      setCurrentPageTitle(translate("EarlyCourseRegistration"));
    });

    return {
      Course,
    };
  },
});
